import React, { useState, useRef, useEffect } from 'react';
import './WinnersPage.css';
import content from '../../config/content';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const WinnersPage = () => {

  const [lightbox, setLightbox] = useState({
    isOpen: false,
    src: "",
    scale: 1,
    x: 0,
    y: 0
  });

  const isDragging = useRef(false);
  const startPos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const originalStyle = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#000";

    return () => {
      document.body.style.backgroundColor = originalStyle;
    };
  }, []);

  const openLightbox = (file) => {
    setLightbox({
      isOpen: true,
      src: `/assets/${file}`,
      scale: 1,
      x: 0,
      y: 0
    });

    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightbox(prev => ({ ...prev, isOpen: false }));
    document.body.style.overflow = 'auto';
  };

  const adjustZoom = (delta) => {
    setLightbox(prev => {
      const newScale = Math.min(Math.max(prev.scale + delta, 1), 5);

      return {
        ...prev,
        scale: newScale,
        x: newScale === 1 ? 0 : prev.x,
        y: newScale === 1 ? 0 : prev.y
      };
    });
  };

  return (
    <div className="winners-page-only">

      <div className="winners-main-container">

        {/* UPDATED TITLE */}
        <h1 className="winners-title">
          Winners of the Ultimate Fluidity Challenge – First Edition
        </h1>

        {/* NEW INTRO TEXT BLOCK */}
        <div className="winners-intro-text">
          <p>
            Explore the winning submissions of the Ultimate Fluidity Challenge – First Edition.
          </p>
          <p>
            With participation from <strong>97 teams from five continents</strong>, this inaugural edition celebrates innovative architectural thinking, expressive form exploration, and exceptional visual storytelling.
          </p>
          <p>
            We extend our sincere appreciation to all participants, our distinguished jury, and our valued partners for their contributions in making this first edition a success. <em>Scroll through the projects and click any image to explore the designs in greater detail.</em>
          </p>
        </div>

        {content.winners.map((winner, index) => (

          <div key={index} className="winner-entry">

            <h2 className="winner-heading">
              {winner.place}: {winner.name}
            </h2>

            <p className="winner-prize-sub">
              {winner.prize}
            </p>

            <p className="winner-description">
              {winner.description}
            </p>

            <div className="carousel-wrapper-custom">

              <Carousel
                showStatus={false}
                showThumbs={false}
                infiniteLoop
                emulateTouch={true}
                swipeable={true}
                showArrows={true}
              >

                {winner.files.map((file, i) => (

                  <div
                    key={i}
                    className="winner-img-frame"
                    onClick={() => openLightbox(file)}
                  >

                    <img
                      src={`/assets/${file}`}
                      alt="Project Architecture"
                    />

                    <div className="click-hint-overlay">
                      <span className="hand-text">
                        CLICK THEN SCROLL TO ZOOM
                      </span>
                    </div>

                  </div>

                ))}

              </Carousel>

            </div>

          </div>

        ))}

      </div>

      {lightbox.isOpen && (

        <div
          className="zoom-lightbox-overlay"
          onClick={closeLightbox}
        >

          <button
            className="zoom-close-x"
            onClick={closeLightbox}
          >
            ×
          </button>

          <div className="zoom-controls">

            <button
              className="zoom-btn"
              onClick={() => adjustZoom(-0.3)}
            >
              −
            </button>

            <button
              className="zoom-btn"
              onClick={() => adjustZoom(0.3)}
            >
              +
            </button>

          </div>

          <div
            className="zoom-lightbox-inner"
            onClick={(e) => e.stopPropagation()}
            onWheel={(e) => adjustZoom(e.deltaY > 0 ? -0.3 : 0.3)}

            onMouseDown={(e) => {
              if (lightbox.scale > 1) {
                isDragging.current = true;

                startPos.current = {
                  x: e.clientX - lightbox.x,
                  y: e.clientY - lightbox.y
                };
              }
            }}

            onMouseMove={(e) => {
              if (isDragging.current) {

                setLightbox(prev => ({
                  ...prev,
                  x: e.clientX - startPos.current.x,
                  y: e.clientY - startPos.current.y
                }));

              }
            }}

            onMouseUp={() => isDragging.current = false}

          >

            <img
              src={lightbox.src}
              alt="Detailed View"
              draggable="false"
              style={{
                transform: `translate(${lightbox.x}px, ${lightbox.y}px) scale(${lightbox.scale})`,
                cursor: lightbox.scale > 1 ? 'grab' : 'zoom-in',
                maxWidth: "90vw",
                maxHeight: "90vh"
              }}
            />

          </div>

        </div>

      )}

    </div>
  );
};

export default WinnersPage;
